import * as React from 'react';
import { MediaQuery, Carousel } from '@grandvisionhq/common';

const ProductBlockCarousel = ({ blockKeys , renderBlock , itemsPerSlide: itemsPerSlideOverride , navigationLocation ,  })=>{
    const [activeIndex, setActiveIndex] = React.useState(0);
    const isDesktop = MediaQuery.useIsDesktop();
    const itemsPerSlide = (itemsPerSlideOverride !== null && itemsPerSlideOverride !== void 0 ? itemsPerSlideOverride : isDesktop) ? 4 : 3;
    const carouselSlides = React.useMemo(()=>{
        const amountOfSlides = Math.ceil(blockKeys.length / itemsPerSlide);
        return Array.from({
            length: amountOfSlides
        }, (_, i)=>{
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            const slideKeys = blockKeys.slice(start, end);
            const slideKey = slideKeys.toString();
            return /*#__PURE__*/ React.createElement("div", {
                key: slideKey,
                className: "product-block-carousel__slide"
            }, slideKeys.map((blockKey)=>{
                const tabIndex = activeIndex !== i ? -1 : undefined;
                return renderBlock({
                    blockKey,
                    tabIndex
                });
            }));
        });
    }, [
        blockKeys,
        itemsPerSlide,
        activeIndex,
        renderBlock
    ]);
    return /*#__PURE__*/ React.createElement(Carousel, {
        className: "product-block-carousel",
        hasNavigation: true,
        navigationLocation: navigationLocation,
        shouldLoopNavigationFocus: true,
        onIndexChange: setActiveIndex
    }, carouselSlides);
};

export { ProductBlockCarousel };
//# sourceMappingURL=ProductBlockCarousel.js.map
